import { combineReducers } from "redux";

import { loginReducer } from "./loginReducer";
import { forgotPasswordReducer } from "./forgotPasswordReducer";
import { recoverAssessmentAccessReducer } from "./recoverAssessmentAccessReducer";

export const authReducer = combineReducers({
  login: loginReducer,
  forgotPassword: forgotPasswordReducer,
  recoverAssessmentAccess: recoverAssessmentAccessReducer,
});
